import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import { RootState } from "./types";
import { searchCondition } from "./modules/searchCondition";
import { yearmonth } from "./modules/yearmonth";
import { yearmonths } from "./modules/yearmonths";
import { showsnackbar } from "./modules/showSnackbar";

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: "0.0.1"
  },
  modules: {
    searchCondition,
    yearmonth,
    yearmonths,
    showsnackbar
  }
};

export default new Vuex.Store<RootState>(store);
